import React, {Component} from 'react';
import {connect} from 'react-redux';
import {createRoleOptions} from './utils';
import {
  retrieveRolesFromPermissions,
  orgRoles,
  getUserEntitiesForEntityType,
} from 'common/utils';
import {mapValuesToBody} from './utils';
import REST from 'go/requests/rest';
import RoleAndProgramForm from './RoleAndProgramForm';
import {ENTITY_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import {MITIGATION_PROGRAMS} from './constants';
import {isSAR, isAOR} from 'go/security/permissions';

import _ from 'lodash';

class orgUserRoleProgramContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      entities: [],
      roles: [],
      programs: [],
      permittedprograms: [],
      subOrgsPrograms: [],
      userEntities: [],
      showValidationError: false,
    };
  }
  async componentDidMount() {
    const {token} = this.props;
    try {
      await Promise.all([
        this.fetchRoles(token),
        this.fetchEntities(token),
        this.fetchUserEntities(token),
      ]);
    } catch (err) {
      console.error(err);
    }
  }

  fetchRoles = async (token) => {
    REST.user
      .getRoles(token)
      .then(REST.handler.handleResponse)
      .then((res) => {
        if (res) {
          this.setState({roles: res});
        }
      })
      .catch((err) => {
        console.error('err');
      });
  };

  fetchEntities = async (token) => {
    REST.user
      .getManagedEntities(token)
      .then(REST.handler.handleResponse)
      .then((res) => {
        if (res) {
          this.setEntities(res);
        }
      })
      .catch((err) => {
        console.error('err');
      });
  };

  setEntities = (entities) => {
    this.setState({entities});
  };

  createUser = (email, values) => {
    const {
      token,
      selectedOrgId,
      renderMemberInfo,
      getUserData,
      userNotFound,
    } = this.props;

    if (!_.isEqual(values.originalUser, values.user)) {
      let body = mapValuesToBody(values, selectedOrgId);
      REST.user
        .modifyUserRoles(token, email, body)
        .then(REST.handler.handleResponse)
        .then((response) => {
          this.props.reloadUserList();
          if (response && !userNotFound) {
            renderMemberInfo('success');
          } else {
            renderMemberInfo('notify');
          }
          getUserData(email, values);
        })
        .catch((err) => {
          console.error('error');
        });
    }
  };

  validatePermissions = (roles, entityTypeId) => {
    return (
      ENTITY_MAP.PROGRAM_ORGANIZATION.code !== String(entityTypeId) ||
      !_.chain(roles).map('programs').map(_.isEmpty).some().value()
    );
  };

  updateUser = async (selectedUser, values) => {
    const {token, selectedOrgId} = this.props;
    if (
      this.validatePermissions(values.user, _.get(selectedUser, 'entityType.entiyTypeId'))
    ) {
      let body = mapValuesToBody(values, selectedOrgId);
      REST.user
        .modifyUserRoles(token, selectedUser.userId, body)
        .then(REST.handler.handleResponse)
        .then((response) => {
          if (response) {
            this.props.reloadUserList();
          }
        })
        .catch((err) => {
          console.error('error');
        });
      this.props.closeManageTeamModal(selectedUser);
    } else if (!_.isEqual(values.originalUser, values.user)) {
      let body = mapValuesToBody(values, selectedOrgId);
      REST.user
        .modifyUserRoles(token, selectedUser.userId, body)
        .then(REST.handler.handleResponse)
        .then((response) => {
          if (response) {
            this.props.reloadUserList();
          }
        })
        .catch((err) => {
          console.error('error');
        });
      this.props.closeManageTeamModal(selectedUser);
    } else {
      this.setState({showValidationError: true});
    }
  };

  fetchUserEntities = async () => {
    this.setState({isLoaded: false}, () => {
      REST.user
        .getEntities(this.props.token)
        .then(REST.handler.handleResponse)
        .then((response) => {
          if (response) {
            this.setState({
              userEntities: response,
              isLoaded: true,
              suborgsAllowed: true,
              isSuborgLoaded: true,
            });
          }
        })
        .catch((error) => {
          console.error('error');
          this.setState({
            userEntities: [],
            error: true,
          });
        });
    });
  };

  selectUnselectAll = (e, values, index, categoryId, setSelectedPrograms) => {
    if (e.target.checked) {
      const programsToAdd = _.filter(
        categoryId.programsList,
        (p) => _.findIndex(values.user[index].programs, {programId: p.programId}) === -1
      ).map((p) => ({
        programId: p.programId,
      }));
      values.user[index].programs = _.concat(values.user[index].programs, programsToAdd);
      setSelectedPrograms(values);
    } else {
      const programsToRemove = categoryId.programsList.map((p) => p.programId);
      values.user[index].programs = values.user[index].programs.filter(
        (p) => !_.includes(programsToRemove, p.programId)
      );
      setSelectedPrograms(values);
    }
  };

  selectUnselectProgram = (e, values, index, programId, arrayHelpers) => {
    if (e.target.checked) {
      arrayHelpers.push({
        programId: programId,
      });
    } else {
      const idx = _.findIndex(values.user[index].programs, {programId: programId});
      arrayHelpers.remove(idx);
    }
  };

  hideSubRoles = () => {
    const {selectedOrgId, parentOrgId, permissions, renderType} = this.props;
    const {userEntities} = this.state;

    const canHaveSubOrganization = userEntities
      .filter((y) => {
        return y.entityId === selectedOrgId;
      })
      .map((x) => {
        return x.canHaveSuborganizations;
      })[0];

    const getUserOrgs = getUserEntitiesForEntityType(
      permissions,
      ENTITY_MAP.ORGANIZATION.code
    );

    const getUserProgramOrgs = getUserEntitiesForEntityType(
      permissions,
      ENTITY_MAP.PROGRAM_ORGANIZATION.code
    );

    const getUserProgramOrgsSubOrg = getUserEntitiesForEntityType(
      permissions,
      ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code
    );

    const userHasOrg = _.includes(getUserOrgs, selectedOrgId);

    const userHasParentOrg = _.includes(getUserOrgs, parentOrgId);

    const userHasParentOrgPrograms =
      _.filter(getUserProgramOrgs, (orgProgram) => _.includes(orgProgram, parentOrgId))
        .length > 0;

    const userHasOrgPrograms =
      _.filter(getUserProgramOrgs, (orgProgram) => _.includes(orgProgram, selectedOrgId))
        .length > 0;

    const getUserPrograms = _.map(
      _.filter(getUserProgramOrgs, (orgProgram) => _.includes(orgProgram, selectedOrgId)),
      (orgProgram) => orgProgram.substr(_.findIndex(orgProgram, '_') - 1)
    );
    const userHasOrgHMAPrograms =
      _.filter(getUserPrograms, (p) => _.includes(MITIGATION_PROGRAMS, parseInt(p)))
        .length > 0;

    const userHasSubOrgPrograms =
      _.filter(getUserProgramOrgsSubOrg, (orgProgram) =>
        _.includes(orgProgram, selectedOrgId)
      ).length > 0;

    const isSarForOwn = isSAR(permissions) && userHasSubOrgPrograms;

    const isAorTypeOneOfParentOrg =
      isAOR(permissions) && userHasOrg && canHaveSubOrganization;

    const isAorTypeFiveOfParentOrgWithSubPrograms =
      isAOR(permissions) &&
      userHasOrgPrograms &&
      userHasOrgHMAPrograms &&
      canHaveSubOrganization;

    const isAorOfParentOrg =
      renderType == 'subOrg' && isAOR(permissions) && userHasParentOrg;

    const isLimitedAorOfParentOrg =
      renderType == 'subOrg' && isAOR(permissions) && userHasParentOrgPrograms;

    return (
      !isSarForOwn &&
      !isAorTypeOneOfParentOrg &&
      !isAorOfParentOrg &&
      !isAorTypeFiveOfParentOrgWithSubPrograms &&
      !isLimitedAorOfParentOrg
    );
  };

  onlySubRoles = () => {
    const {selectedOrgId, permissions} = this.props;

    const getUserOrgs = getUserEntitiesForEntityType(
      permissions,
      ENTITY_MAP.ORGANIZATION.code
    );
    const getUserProgramOrgs = getUserEntitiesForEntityType(
      permissions,
      ENTITY_MAP.PROGRAM_ORGANIZATION.code
    );

    const userHasOrg = _.includes(getUserOrgs, selectedOrgId);
    const userHasOrgPrograms =
      _.filter(getUserProgramOrgs, (orgProgram) => _.includes(orgProgram, selectedOrgId))
        .length > 0;

    return !userHasOrg && !userHasOrgPrograms;
  };

  render() {
    const {
      permissions,
      selectedOrgId,
      isLoggedInAOR,
      selectedUser,
      userNotFound,
      userId,
      loginuserId,
      renderMemberInfo,
      getUserData,
      openManageTeamModal,
      closeManageTeamModal,
      subOrgToggle,
      renderType,
      reloadUserList,
      parentOrgId,
      parentOrgs,
      displayNameParent,
    } = this.props;
    const {entities, roles, userEntities} = this.state;

    const ENTITY = entities
      .filter((x) => {
        return x.entityId === subOrgToggle && renderType == 'subOrg'
          ? parentOrgId
          : selectedOrgId;
      })
      .map((x) => {
        return x.displayName;
      })[0];

    const rolePermissions = retrieveRolesFromPermissions(permissions);
    let roleOptions = createRoleOptions(roles, rolePermissions, subOrgToggle);
    const orgTeamRoles = orgRoles(permissions, renderType, subOrgToggle);

    if (this.onlySubRoles()) {
      roleOptions = {
        [ENTITY]: [
          {
            text: 'Subrecipient Member',
            value: 'Subrecipient Member',
          },
          {
            text: 'Subrecipient Authorized Representative',
            value: 'Subrecipient Authorized Representative',
          },
        ],
      };
    }

    if (this.hideSubRoles()) {
      _.remove(roleOptions[ENTITY], {
        text: 'Subrecipient Member',
        value: 'Subrecipient Member',
      });
      _.remove(roleOptions[ENTITY], {
        text: 'Subrecipient Authorized Representative',
        value: 'Subrecipient Authorized Representative',
      });

      roleOptions = {[ENTITY]: roleOptions[ENTITY]};
    }

    let AOR_USER;
    if (selectedUser) {
      AOR_USER = isLoggedInAOR(selectedUser);
    }
    return (
      <React.Fragment>
        <RoleAndProgramForm
          role_opts={roleOptions}
          orgName={ENTITY}
          roles={rolePermissions}
          isLoggedInAOR={isLoggedInAOR}
          isAORUser={AOR_USER}
          userNotFound={userNotFound}
          userId={userId}
          renderMemberInfo={renderMemberInfo}
          originalUser={selectedUser}
          selectedUser={selectedUser}
          programs={this.props.programs}
          assignedPrograms={this.props.assignedPrograms}
          getUserData={getUserData}
          openManageTeamModal={openManageTeamModal}
          closeManageTeamModal={closeManageTeamModal}
          createUser={this.createUser}
          updateUser={this.updateUser}
          showValidationError={this.state.showValidationError}
          parentOrgs={parentOrgs}
          orgTeamRoles={orgTeamRoles}
          renderType={renderType}
          subOrgToggle={subOrgToggle}
          toggles={this.props.toggles}
          reloadUserList={reloadUserList}
          orgs={this.props.orgs}
          selectedOrgId={selectedOrgId}
          permissions={permissions}
          userEntities={userEntities}
          displayNameParent={displayNameParent}
          parentOrgId={parentOrgId}
          selectUnselectAll={this.selectUnselectAll}
          selectUnselectProgram={this.selectUnselectProgram}
          loginuserId={loginuserId}
        />
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    permissions: state.auth.permissions,
    orgId: state.userSessionData.orgId,
    toggles: state.toggles.toggles,
    loginuserId: state.auth.userId,
  };
};

export default connect(mapStateToProps, null)(orgUserRoleProgramContainer);
